import React from "react";
import {observer} from "mobx-react-lite";
import {useSitStores} from "../../../../stores";

export const InitiativeSkuForm: React.FC = observer(() => {
    const {initiativeInstanceStore: s} = useSitStores();
    const dis = s.disabled;

    return (
        <div className="sit-miles">
            {s.sku_c.length === 0 && <div className="sit-muted">No SKUs linked.</div>}
            {s.sku_c.map((sku, index) => (
                <div className="sit-mile" key={index}>
                    <input className="sit-mile-text" placeholder="Enter SKU number" value={sku.p_id} disabled={dis}
                           onChange={e => sku.p_id = e.target.value}/>
                    <button type="button" className="sit-rm-btn" disabled={dis}
                            onClick={() => s.removeSku(index)} aria-label="Remove">✕
                    </button>
                </div>
            ))}
            <button type="button" className="sit-add-line" disabled={dis} onClick={() => s.addSku()}>
                + Add SKU number
            </button>
        </div>
    );
});
